/**
 * StartMeetingPage — TASK-673 / TASK-672 (summon-redirect).
 *
 * Target of a reminder alert's recovery actions (`/meeting/:id/start|reschedule|cancel`).
 * Rather than rendering a full routed page, it summons the Meetings list onto the canvas and
 * tells it to open the right control for this exact session (capture chooser / reschedule modal
 * / cancel modal), then redirects to `/dashboard` — so the flow lands on the canvas, never on a
 * page. Mirrors the `/meetings` → `MeetingsList` redirect pattern.
 */

import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { useCanvasActions } from '../stores/canvasStore';

type MeetingAction = 'start' | 'reschedule' | 'cancel';

const AUTO_PROP: Record<MeetingAction, string> = {
  start: 'autoStartSessionId',
  reschedule: 'autoRescheduleSessionId',
  cancel: 'autoCancelSessionId',
};

const StartMeetingPage: React.FC<{ action?: MeetingAction }> = ({ action = 'start' }) => {
  const { id } = useParams<{ id: string }>();
  const { addSpecs } = useCanvasActions();

  useEffect(() => {
    if (id) addSpecs([{ component: 'MeetingsList', props: { [AUTO_PROP[action]]: id } }]);
  }, [id, action, addSpecs]);

  return <Navigate to="/dashboard" replace />;
};

export default StartMeetingPage;
